import { useState, useEffect, useCallback, useRef } from 'react';
import { getWrongAnswers } from '../api/assessment';

export default function useWrongAnswers(assessmentId, { enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const inflight = useRef(false);
  const attempted = useRef(false);
  const alive = useRef(true);

  useEffect(() => () => { alive.current = false; }, []);

  const fetchOnce = useCallback(async () => {
    if (!assessmentId || inflight.current) return;
    inflight.current = true;
    attempted.current = true;
    setLoading(true);
    setError(null);
    try {
      const resp = await getWrongAnswers(assessmentId);
      if (!alive.current) return;
      setData(resp.data);
    } catch (err) {
      if (!alive.current) return;
      setError(err);
    } finally {
      inflight.current = false;
      if (alive.current) setLoading(false);
    }
  }, [assessmentId]);

  const refetch = useCallback(() => {
    attempted.current = false;
    setError(null);
    return fetchOnce();
  }, [fetchOnce]);

  useEffect(() => {
    if (!enabled || !assessmentId || attempted.current) return;
    fetchOnce();
  }, [enabled, assessmentId, fetchOnce]);

  const itemsForDimension = useCallback((dimensionId) => {
    const byDim = data?.by_dimension || {};
    return byDim[String(dimensionId)] || [];
  }, [data]);

  return { data, loading, error, refetch, itemsForDimension };
}
